package com.ai.mitra.presentation.screens.chatscreen

import com.ai.mitra.domain.model.ChatMessage

data class ChatUiState(
    val message: List<ChatMessage> = emptyList(),
    val isApiLoading: Boolean = false,
    val isLoading: Boolean = false,
)